<template>
    <v-container fluid fill-height indigo_5>
        <v-layout column align-center justify-center>
            <v-flex xs12 sm6 md8 lg8>
                <!-- header -->
                <div class="entrance__header">
                    <!-- logo -->
                    <div class="entrance__logo-img">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="37"
                            height="37"
                            fill="none"
                            viewBox="0 0 37 37"
                        >
                            <path fill="#fff" d="M0 0h37v37H0z"></path>
                            <path
                                fill="#547685"
                                fill-rule="evenodd"
                                d="M12.646 27.584h11.853l3.527 4.17H9.25l3.396-4.17z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                fill="#fff"
                                fill-rule="evenodd"
                                d="M18.638 29.943c1.584 0 2.869-.27 2.869-.603 0-.334-1.285-.604-2.869-.604-1.584 0-2.869.27-2.869.604 0 .333 1.285.603 2.869.603z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                fill="#fff"
                                d="M18.638 5.384c-4.79 0-8.686 3.9-8.686 8.693 0 5.949 7.773 14.682 8.104 15.05a.782.782 0 0 0 1.164 0c.331-.368 8.105-9.101 8.105-15.05 0-4.793-3.897-8.693-8.687-8.693z"
                            ></path>
                            <mask
                                id="a"
                                width="19"
                                height="25"
                                x="9"
                                y="5"
                                maskUnits="userSpaceOnUse"
                            >
                                <path
                                    fill="#fff"
                                    d="M18.638 5.384c-4.79 0-8.686 3.9-8.686 8.693 0 5.949 7.773 14.682 8.104 15.05a.782.782 0 0 0 1.164 0c.331-.368 8.105-9.101 8.105-15.05 0-4.793-3.897-8.693-8.687-8.693z"
                                ></path>
                            </mask>
                            <g mask="url(#a)">
                                <path
                                    fill="#547685"
                                    fill-rule="evenodd"
                                    d="M23.838 5.103h-5.2v24.565h18.598V5.103H23.838z"
                                    clip-rule="evenodd"
                                ></path>
                            </g>
                            <path
                                fill="#fff"
                                fill-rule="evenodd"
                                d="M27.352 14.077c0-4.793-3.91-8.693-8.714-8.693-4.805 0-8.713 3.9-8.713 8.693 0 5.949 7.797 14.682 8.13 15.05a.786.786 0 0 0 1.167 0c.332-.368 8.13-9.101 8.13-15.05zm-6.12 8.158c2.199-3.284 3.496-6.211 3.496-8.158 0-3.343-2.733-6.07-6.09-6.07-3.357 0-6.09 2.727-6.09 6.07 0 1.947 1.297 4.874 3.496 8.158a50.22 50.22 0 0 0 2.594 3.516 50.188 50.188 0 0 0 2.594-3.516z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                fill="#547685"
                                fill-rule="evenodd"
                                d="M27.352 14.077c0-4.793-3.91-8.693-8.714-8.693-4.805 0-8.713 3.9-8.713 8.693 0 5.949 7.797 14.682 8.13 15.05a.786.786 0 0 0 1.167 0c.332-.368 8.13-9.101 8.13-15.05zm-5.432 8.619a51.137 51.137 0 0 1-3.282 4.36 51.138 51.138 0 0 1-3.282-4.36c-2.284-3.41-3.637-6.463-3.637-8.619 0-3.801 3.105-6.898 6.92-6.898 3.813 0 6.918 3.097 6.918 6.898 0 2.156-1.353 5.209-3.637 8.619z"
                                clip-rule="evenodd"
                            ></path>
                            <path
                                fill="#fff"
                                d="M18.694 18.006c-2.232 0-4.047-1.795-4.047-4 0-2.207 1.815-4.001 4.047-4.001 2.232 0 4.048 1.794 4.048 4s-1.816 4-4.048 4z"
                            ></path>
                            <path
                                fill="#547685"
                                d="M18.694 16.991a2.93 2.93 0 0 1 0-5.86 2.93 2.93 0 0 1 0 5.86z"
                            ></path>
                        </svg>
                    </div>

                    <!-- title -->
                    <h1
                        class="entrance__logo-text white--text text-uppercase ml-2"
                    >
                        Безопасный город
                    </h1>
                </div>

                <v-flex xs12 sm12 md12 lg12>
                    <!-- forms -->
                    <div class="flip-container">
                        <transition name="flip" mode="out-in">
                            <component
                                :is="selectedComponent"
                                v-on:show="toggle"
                            ></component>
                        </transition>
                    </div>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import signinForm from '@/components/signinForm';
import recoveryForm from '@/components/recoveryForm';

export default {
    components: {
        signinForm,
        recoveryForm,
    },

    data: () => ({
        selectedComponent: signinForm,
    }),

    // beforeCreate() {
    //   this.$store.state.showNavbar = false;
    // },

    methods: {
        // change forms on click
        toggle() {
            this.selectedComponent == 'signinForm'
                ? (this.selectedComponent = 'recoveryForm')
                : (this.selectedComponent = 'signinForm');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';

.entrance {
    &__header {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
    }

    &__logo-text {
        font-size: 36px;

        @media screen and(max-width: 600px) {
            font-size: 24px;
        }
    }
}

// form changing animation
.flip-container {
    width: 100%;
    perspective: 1000px;
    transform-style: preserve-3d;
}

.flip-leave-enter {
    transform: rotateY(0deg);
}

.flip-leave-to {
    transform: rotateY(90deg);
}

.flip-enter {
    transform: rotateY(-90deg);
}

.flip-enter-to {
    transform: rotateY(0deg);
}

.flip-enter-active,
.flip-leave-active {
    transition: all 0.4s linear;
}
</style>
